<template>
  <div class="agency-list">
    <searchBar class="search-bar" title="渠道管理" :searchWidth="1100"/>
    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{ background: '#66b1ff' ,color:'#fff'}"
      :row-class-name="tableRowClassName"
    >
      <el-table-column v-bind="item" v-for="(item,i) in tableHeader" :key="i"></el-table-column>
      <el-table-column
      fixed="right"
      label="操作"
      width="180">
      <template slot-scope="scope">
        <el-button @click="handleClick(scope.row)" type="primary" size="mini">编辑</el-button>
        <el-button @click="handleClick(scope.row)" type="warning" size="mini">启用</el-button>
      </template>
    </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage4"
        :page-sizes="[10, 20, 50, 100 ,200]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="400"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import searchBar from "@/components/search-bar";
export default {
  components: {
    searchBar,
  },
  data() {
    return {
      tableHeader: [
        {
          prop: "date",
          label: "归属人",
          width: "80",
          fixed: 'left',
        },
        {
          prop: "name",
          label: "渠道ID",
          width: "80",
        },
        {
          prop: "date",
          label: "渠道名称",
          width: "80",
        },
        {
          prop: "name",
          label: "推广域名",
        },
        {
          prop: "date",
          label: "落地页模板",
          width: "120",
        },
        {
          prop: "name",
          label: "代理ID",
          width: "80",
        },
        {
          prop: "date",
          label: "代理名称",
          width: "80",
        },
        {
          prop: "name",
          label: "状态",
          width: "80",
        },
        {
          prop: "date",
          label: "创建日期",
          width: "80",
        }
      ],
      tableData: [
        {
          date: "2016",
          name: "王小虎",
          address: "上海市",
        },
        {
          date: "2016",
          name: "王小虎",
          address: "上海市",
        },
        {
          date: "2016",
          name: "王小虎",
          address: "上海市",
        },
        {
          date: "2016",
          name: "王小虎",
          address: "区金沙",
        },
      ],
      currentPage4: 1
    };
  },

  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 !== 0) {
        return "first-row";
      } else {
        return "second-row";
      }
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
  },
};
</script>

<style lang="less" >
.agency-list {
  position: relative;
  .first-row {
    background: rgb(219, 219, 219) !important;
  }

  .second-row {
    background: #d4e4fc !important;
  }

  .search-bar {
    margin-bottom: 30px;
  }

  .pagination{
    margin-top: 30px;
    position: absolute;
    right: 50px;
  }
}
</style>